import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { ArrowRight, Sparkles, Clapperboard, Feather } from "lucide-react";
import { ToolSpecs } from "@/components/ToolSpecs";
import { CinematicVideo } from "@/components/CinematicVideo";

const CAPSULES_VIDEO = "https://customer-assets-7cd3h4nn.emergentagent.net/job_epiphany-mentor/artifacts/lp6ap55n_gemini_generated_video_f67598c9.mp4";

const T = {
  fr: { badge: "Curiosité", title: "Les Capsules de curiosité", sub: "Des micro-fulgurances générées par l'IA : mythes déboulonnés, astuces, paradoxes, mots rares, chiffres fous. Une bouchée de savoir, à la demande.", cta: "Ouvrir une capsule", f1: "10 formats", f2: "à la demande", f3: "en 30 secondes" },
  en: { badge: "Curiosity", title: "Curiosity Capsules", sub: "AI-generated micro-sparks: busted myths, tips, paradoxes, rare words, wild numbers. A bite of knowledge, on demand.", cta: "Open a capsule", f1: "10 formats", f2: "on demand", f3: "in 30 seconds" },
  es: { badge: "Curiosidad", title: "Cápsulas de Curiosidad", sub: "Micro-destellos generados por IA: mitos derribados, trucos, paradojas, palabras raras, cifras locas. Un bocado de saber, a demanda.", cta: "Abrir una cápsula", f1: "10 formatos", f2: "a demanda", f3: "en 30 segundos" },
  nl: { badge: "Nieuwsgierigheid", title: "Nieuwsgierigheidscapsules", sub: "AI-gegenereerde micro-flitsen: ontkrachte mythes, tips, paradoxen, zeldzame woorden, gekke cijfers. Een hap kennis, op aanvraag.", cta: "Open een capsule", f1: "10 formaten", f2: "op aanvraag", f3: "in 30 seconden" },
};

export const CapsulesTeaser = () => {
  const { i18n } = useTranslation();
  const lng = (i18n.language || "fr").slice(0, 2);
  const c = T[lng] || T.fr;
  return (
    <section className="relative px-4 md:px-8 py-16" data-testid="capsules-teaser">
      <div className="max-w-6xl mx-auto relative overflow-hidden rounded-[2rem] border border-primary/25 glass frame-pulse">
        <div aria-hidden className="absolute -left-24 -bottom-24 w-[520px] h-[520px] rounded-full pointer-events-none"
          style={{ background: "radial-gradient(circle, hsl(28 96% 56% / 0.16), transparent 62%)" }} />
        <div className="relative z-10 grid lg:grid-cols-2 gap-8 items-center p-8 sm:p-12">
          {/* Cinématique : Les Capsules de curiosité */}
          <div className="relative flex items-center justify-center order-2 lg:order-1" data-testid="capsules-teaser-cinematic">
            <CinematicVideo fade noSound silver src={CAPSULES_VIDEO} testId="capsules-teaser-video" className="w-full" caption={c.title} />
          </div>
          <div className="order-1 lg:order-2">
            <span className="inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] font-semibold px-3 py-1 rounded-full bg-primary text-background shadow-[0_0_14px_hsl(38_90%_55%/0.5)]">{c.badge}</span>
            <h2 className="mt-5 font-display text-gradient-orange text-4xl sm:text-5xl leading-none pb-[0.05em]">{c.title}</h2>
            <p className="mt-4 text-foreground/65 leading-relaxed max-w-md">{c.sub}</p>
            <ToolSpecs lang={lng} className="mt-6 max-w-md"
              items={[{ Icon: Clapperboard, text: c.f1 }, { Icon: Feather, text: c.f2 }, { Icon: Sparkles, text: c.f3 }]} />
            <Link to="/univers/la-bibliotheque#les-capsules" data-testid="capsules-teaser-cta"
              className="btn-frost-orange mt-8 inline-flex items-center gap-2 px-8 py-3.5 rounded-full font-semibold">
              {c.cta} <ArrowRight size={17} />
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};
